import { createSlice } from '@reduxjs/toolkit';

/**
 * Stores the base token from liquidity-pool-creator success flow so that
 * when the user redirects to /token-burn, that token can be auto-selected.
 */
const initialState = {
  /** { mintAddress, symbol?, name?, logo?, decimals? } or null */
  prefillToken: null,
};

const burnPagePrefillSlice = createSlice({
  name: 'burnPagePrefill',
  initialState,
  reducers: {
    setBurnPagePrefillToken: (state, action) => {
      state.prefillToken = action.payload;
    },
    clearBurnPagePrefillToken: (state) => {
      state.prefillToken = null;
    },
  },
});

export const { setBurnPagePrefillToken, clearBurnPagePrefillToken } = burnPagePrefillSlice.actions;
export const selectBurnPagePrefillToken = (state) => state.burnPagePrefill.prefillToken;
export default burnPagePrefillSlice.reducer;
